import type { IOrgProjectLocationRepository, ProjectSubscribeInput } from '../repositories/IOrgProjectLocationRepository.js';
import type { ProjectLocationEntity } from '../entities/OrgLocationEntity.js';

interface Deps { orgProjectLocationRepository: IOrgProjectLocationRepository; }

export function createSubscribeProjectLocationUseCase({ orgProjectLocationRepository }: Deps) {
  return async function subscribeProjectLocation(input: ProjectSubscribeInput): Promise<ProjectLocationEntity> {
    // Auto-subscribe to org if not already (idempotent upsert)
    await orgProjectLocationRepository.ensureOrgSubscription(input.orgId, input.locationId);
    return orgProjectLocationRepository.subscribeProject(input);
  };
}
